import { flFetch as fetch, validateStatus } from "./fetch";

export const fetchCountriesAndStates = () => {
  return fetch(`${process.env.REACT_APP_API_URL}/info/countries-and-states`, {
    method: "GET"
  }).then(validateStatus);
};

export const fetchStateTitleTypes = () => {
  return fetch(`${process.env.REACT_APP_API_URL}/info/state-title-types`, {
    method: "GET"
  }).then(validateStatus);
};
